import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <AboutSection />
        <IndexSection />
        <ContactSection />
        <UpdatesSection />
        <FAQSection />
        <FeaturesSection />
        <RankingSection />
        <AppSection />
        <TopicsSection />
        <CarouselSection />
        <CardsSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}